exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".list-item {\n  display: inline-block;\n  height: 95%;\n  width: calc(100% - 7px);\n  border-color: white;\n  border-style: solid;\n  border-width: 1px;\n  border-radius: 3px;\n  margin-top: 1px;\n  margin-bottom: 1px;\n  background-color: black;\n  color: white;\n  padding-left: 5px;\n  text-align: left;\n  vertical-align: middle;\n  text-anchor: middle; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/Workspace/hyblab-migration/src/app/country-list/country-list.component.scss
// module id = ../../../../../src/app/country-list/country-list.component.scss
// module chunks = main